import Skeleton from "react-loading-skeleton";

export const PaymentDetailsLeft = ({loadingPlans,estimatedData,plans,user,number_of_kids}) => {
  return (
    <>
      <div className="d-flex d-md-none d-block mb-4 justify-content-center align-items-center">
        {loadingPlans ? (
          <Skeleton height={60} width={100} />
        ) : (
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQLogo.png"
            alt="img"
          />
        )}
      </div>
      <div className="col-md-5 custom-box">
        {estimatedData?.trial_eligibility && (
          <div className="d-flex mb-4 justify-content-center align-items-center position-relative d-inline-block">
            <div
              className=" webUi"
              style={{
                backgroundColor: "blue", // Or any gray shade
                borderRadius: "40px",
                padding: "10px 20px 10px 20px",
                fontWeight: "500",
                fontSize: "12px",
                color: "#ffffff",
                display: "inline-block",
              }}
            >
              Try it free for {plans?.plans?.[0]?.trial_days} days. Cancel
              anytime.
            </div>
          </div>
        )}
        <div className="d-flex mb-4 justify-content-center align-items-center">
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/parentadmin/registration/payment/imagegroup.png"
            alt="img"
            className="img-fluid"
          />
        </div>
        <div className="card p-3" style={{ borderRadius: "10px" }}>
          <div className="d-flex align-items-center">
            <div className="me-3 text-primary">
              <i className="bi bi-person-circle fs-2"></i>
            </div>
            <div>
              <h6 className="mb-0">
                {user?.firstName ? user?.firstName : user?.user?.firstName}{" "}
                {user?.lastName ? user?.lastName : user?.user?.lastName}
              </h6>
              <small>{user?.user?.email || user?.email}</small>
            </div>
          </div>
        </div>

        {estimatedData?.affective_unit_price?.map((kid, index) => {
          return (
            <div className="card p-3 mt-4" style={{ borderRadius: "10px" }}>
              <div className="d-flex align-items-center">
                <div className="me-3 text-primary">
                  <i
                    className={`bi bi-currency-${
                      plans?.plans?.[0]?.currency === "USD" ? "dollar" : "rupee"
                    } fs-2`}
                  ></i>
                </div>
                <div>
                  <p className="mb-0">
                    Price per kid{" "}
                    <small className="text-muted">(Billed Annually)</small>
                  </p>
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <span className="fs-5 fw-semibold">
                      Kid {kid?.quantity}
                    </span>
                    <span className="fs-5 fw-semibold">
                      {plans?.plans?.[0]?.currency === "USD" ? "$" : "₹"}{" "}
                      {kid?.discounted ?? kid?.original}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        <div
          className="card p-3 mt-4 "
          style={{
            borderRadius: "10px",
          }}
        >
          <div className="d-flex align-items-center">
            <div className="me-3 text-primary">
              <i className="bi bi-people fs-2"></i>
            </div>
            <div>
              <p className="mb-0">
                Number of Kids
                {/* {Number(number_of_kids) > 1 ? "s" : ""} */}
              </p>
              <span className="fs-4 fw-semibold">{number_of_kids}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
